const translations = {
  fr: {
    nav: {
      services: "Services",
      method: "Notre méthode",
      values: "Nos valeurs",
      testimonials: "Témoignages",
      contact: "Contact",
      cta: "Nous contacter",
    },
    hero: {
      title: "Un accompagnement humain et personnalisé pour vos proches",
      subtitle: "Parce que vieillir ne signifie pas arrêter de vivre",
      cta1: "Demander un appel",
      cta2: "Prendre contact",
    },
    problem: {
      line1: "Aimeriez-vous pouvoir faire plus pour vos proches… sans être seul au quotidien ?",
      line2: "Vous cherchez une présence de confiance ?",
      description:
        "Nous comprenons vos préoccupations. C'est pourquoi nous offrons un accompagnement chaleureux et professionnel, pensé pour le bien-être de vos aînés.",
    },
    services: {
      label: "Nos services",
      title: "Un accompagnement adapté à chaque besoin",
      items: [
        {
          title: "Rendez-vous médicaux",
          description:
            "Accompagnement aux consultations médicales, suivi des rendez-vous et soutien administratif lié à la santé.",
        },
        {
          title: "Promenades et sorties",
          description:
            "Balades en plein air, sorties culturelles et découvertes pour garder le plaisir de vivre au quotidien.",
        },
        {
          title: "Repas et convivialité",
          description:
            "Partage de repas, aide à la préparation et moments chaleureux autour de la table.",
        },
        {
          title: "Courses et démarches",
          description:
            "Aide aux courses alimentaires, démarches administratives et accompagnement dans les tâches du quotidien.",
        },
        {
          title: "Activités sociales",
          description:
            "Jeux, lectures, échanges et activités stimulantes pour maintenir le lien social et l'épanouissement.",
        },
      ],
    },
    method: {
      label: "Notre méthode",
      title: "Un processus simple et humain",
      steps: [
        {
          number: "01",
          title: "Premier échange",
          description:
            "Nous prenons le temps de vous écouter, de comprendre votre situation et les besoins de votre proche.",
        },
        {
          number: "02",
          title: "Identification des besoins",
          description:
            "Ensemble, nous définissons un plan d'accompagnement personnalisé, adapté au rythme et aux envies.",
        },
        {
          number: "03",
          title: "Accompagnement sur mesure",
          description:
            "Notre équipe intervient avec bienveillance, professionnalisme et une attention constante au bien-être.",
        },
      ],
    },
    values: {
      label: "Nos valeurs",
      title: "Ce qui nous anime au quotidien",
      items: [
        {
          title: "Attention",
          description:
            "Chaque personne est unique. Nous accordons une attention particulière à chaque détail pour un accompagnement adapté.",
        },
        {
          title: "Professionnalisme",
          description:
            "Formation continue, rigueur et engagement définissent notre approche pour garantir un service de qualité.",
        },
        {
          title: "Coeur",
          description:
            "L'humanité est au centre de tout ce que nous faisons. Nous accompagnons avec chaleur, empathie et sincérité.",
        },
      ],
    },
    testimonials: {
      label: "Témoignages",
      title: "Ce que disent nos familles",
      items: [
        {
          quote:
            "Grâce à Présence & Sourire, ma mère retrouve le sourire chaque semaine. L'accompagnatrice est devenue comme une amie pour elle.",
          author: "Marie-Claire D.",
          relation: "Fille d'une bénéficiaire",
        },
        {
          quote:
            "Un service humain et professionnel. Mon père attend avec impatience ses promenades du mardi. Merci pour votre bienveillance.",
          author: "Philippe R.",
          relation: "Fils d'un bénéficiaire",
        },
        {
          quote:
            "Je vis loin de ma mère et je me sentais coupable. Présence & Sourire m'a redonné la sérénité. Je sais qu'elle est entre de bonnes mains.",
          author: "Isabelle M.",
          relation: "Fille d'une bénéficiaire",
        },
      ],
    },
    contact: {
      label: "Contact",
      title: "Prenons le temps d'échanger",
      subtitle:
        "Remplissez le formulaire ci-dessous et nous vous recontacterons dans les plus brefs délais.",
      form: {
        name: "Votre nom",
        phone: "Votre téléphone",
        message: "Votre message (optionnel)",
        submit: "Envoyer ma demande",
        sending: "Envoi en cours...",
        success: "Merci ! Nous vous recontacterons très bientôt.",
        error: "Une erreur est survenue. Veuillez réessayer.",
      },
      calendly: {
        title: "Réserver un créneau",
        description: "Planifiez un appel découverte avec notre équipe.",
        button: "Choisir un créneau",
      },
      whatsapp: "Discuter sur WhatsApp",
      call: "Nous appeler",
    },
    footer: {
      description:
        "Accompagnement et loisirs pour seniors et personnes à mobilité réduite et en situation de handicap (physique et psychique). Parce que chaque moment compte.",
      quickLinks: "Liens rapides",
      contactTitle: "Contact",
      location: "Valais, Suisse",
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      rights: "Tous droits réservés.",
      followUs: "Suivez-nous",
    },
    whatsappFloat: "Discutons sur WhatsApp",
  },
  de: {
    nav: {
      services: "Dienstleistungen",
      method: "Unsere Methode",
      values: "Unsere Werte",
      testimonials: "Erfahrungen",
      contact: "Kontakt",
      cta: "Kontaktieren Sie uns",
    },
    hero: {
      title: "Eine menschliche und persönliche Begleitung für Ihre Angehörigen",
      subtitle: "Weil Älterwerden nicht bedeutet, aufzuhören zu leben",
      cta1: "Rückruf anfordern",
      cta2: "Kontakt aufnehmen",
    },
    problem: {
      line1: "Fehlt Ihnen die Zeit, Ihre Angehörigen zu begleiten?",
      line2: "Suchen Sie eine vertrauenswürdige Begleitung?",
      description:
        "Wir verstehen Ihre Sorgen. Deshalb bieten wir eine herzliche und professionelle Begleitung, die auf das Wohlbefinden Ihrer Senioren ausgerichtet ist.",
    },
    services: {
      label: "Unsere Dienstleistungen",
      title: "Eine Begleitung angepasst an jeden Bedarf",
      items: [
        {
          title: "Arzttermine",
          description:
            "Begleitung zu Arztterminen, Terminverfolgung und administrative Unterstützung im Gesundheitsbereich.",
        },
        {
          title: "Spaziergänge und Ausflüge",
          description:
            "Spaziergänge, kulturelle Ausflüge und Entdeckungen für die tägliche Lebensfreude.",
        },
        {
          title: "Mahlzeiten und Geselligkeit",
          description:
            "Gemeinsame Mahlzeiten, Hilfe bei der Zubereitung und gesellige Momente am Tisch.",
        },
        {
          title: "Einkäufe und Erledigungen",
          description:
            "Hilfe beim Einkaufen, administrative Erledigungen und Begleitung bei Alltagsaufgaben.",
        },
        {
          title: "Soziale Aktivitäten",
          description:
            "Spiele, Lesen, Austausch und anregende Aktivitäten zur Pflege sozialer Kontakte.",
        },
      ],
    },
    method: {
      label: "Unsere Methode",
      title: "Ein einfacher und menschlicher Prozess",
      steps: [
        {
          number: "01",
          title: "Erstes Gespräch",
          description:
            "Wir nehmen uns Zeit, Ihnen zuzuhören und die Bedürfnisse Ihrer Angehörigen zu verstehen.",
        },
        {
          number: "02",
          title: "Bedarfsermittlung",
          description:
            "Gemeinsam erstellen wir einen personalisierten Begleitplan, abgestimmt auf Rhythmus und Wünsche.",
        },
        {
          number: "03",
          title: "Massgeschneiderte Begleitung",
          description:
            "Unser Team handelt mit Wohlwollen, Professionalität und ständiger Aufmerksamkeit für das Wohlbefinden.",
        },
      ],
    },
    values: {
      label: "Unsere Werte",
      title: "Was uns täglich antreibt",
      items: [
        {
          title: "Aufmerksamkeit",
          description:
            "Jeder Mensch ist einzigartig. Wir schenken jedem Detail besondere Aufmerksamkeit.",
        },
        {
          title: "Professionalität",
          description:
            "Weiterbildung, Sorgfalt und Engagement definieren unseren Ansatz für Qualität.",
        },
        {
          title: "Herz",
          description:
            "Menschlichkeit steht im Zentrum. Wir begleiten mit Wärme, Empathie und Aufrichtigkeit.",
        },
      ],
    },
    testimonials: {
      label: "Erfahrungen",
      title: "Was unsere Familien sagen",
      items: [
        {
          quote:
            "Dank Présence & Sourire lächelt meine Mutter jede Woche wieder. Die Begleiterin ist wie eine Freundin für sie geworden.",
          author: "Marie-Claire D.",
          relation: "Tochter einer Begünstigten",
        },
        {
          quote:
            "Ein menschlicher und professioneller Service. Mein Vater freut sich auf seine Dienstagsspaziergänge.",
          author: "Philippe R.",
          relation: "Sohn eines Begünstigten",
        },
        {
          quote:
            "Ich lebe weit von meiner Mutter entfernt. Présence & Sourire hat mir Gelassenheit zurückgegeben.",
          author: "Isabelle M.",
          relation: "Tochter einer Begünstigten",
        },
      ],
    },
    contact: {
      label: "Kontakt",
      title: "Nehmen wir uns Zeit für ein Gespräch",
      subtitle:
        "Füllen Sie das Formular aus und wir melden uns schnellstmöglich bei Ihnen.",
      form: {
        name: "Ihr Name",
        phone: "Ihre Telefonnummer",
        message: "Ihre Nachricht (optional)",
        submit: "Anfrage senden",
        sending: "Wird gesendet...",
        success: "Vielen Dank! Wir melden uns in Kürze bei Ihnen.",
        error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
      },
      calendly: {
        title: "Termin buchen",
        description: "Planen Sie ein Kennenlerngespräch mit unserem Team.",
        button: "Zeitfenster wählen",
      },
      whatsapp: "Auf WhatsApp schreiben",
      call: "Uns anrufen",
    },
    footer: {
      description:
        "Begleitung und Freizeit für Senioren und Menschen mit Behinderungen. Weil jeder Moment zählt.",
      quickLinks: "Schnelllinks",
      contactTitle: "Kontakt",
      location: "Wallis, Schweiz",
      legal: "Impressum",
      privacy: "Datenschutz",
      rights: "Alle Rechte vorbehalten.",
      followUs: "Folgen Sie uns",
    },
    whatsappFloat: "Auf WhatsApp chatten",
  },
  en: {
    nav: {
      services: "Services",
      method: "Our Method",
      values: "Our Values",
      testimonials: "Testimonials",
      contact: "Contact",
      cta: "Get in Touch",
    },
    hero: {
      title: "A human and personalized accompaniment for your loved ones",
      subtitle: "Because aging does not mean stopping to live",
      cta1: "Request a call",
      cta2: "Get in touch",
    },
    problem: {
      line1: "Do you lack time to accompany your loved ones?",
      line2: "Are you looking for a trustworthy presence?",
      description:
        "We understand your concerns. That's why we offer warm and professional accompaniment, designed for the well-being of your seniors.",
    },
    services: {
      label: "Our Services",
      title: "Support tailored to every need",
      items: [
        {
          title: "Medical Appointments",
          description:
            "Accompaniment to medical consultations, appointment tracking and health-related administrative support.",
        },
        {
          title: "Walks and Outings",
          description:
            "Outdoor walks, cultural outings and discoveries to keep the joy of living every day.",
        },
        {
          title: "Meals and Companionship",
          description:
            "Shared meals, help with preparation and warm moments around the table.",
        },
        {
          title: "Shopping and Errands",
          description:
            "Help with grocery shopping, administrative tasks and accompaniment in daily errands.",
        },
        {
          title: "Social Activities",
          description:
            "Games, reading, conversations and stimulating activities to maintain social connections.",
        },
      ],
    },
    method: {
      label: "Our Method",
      title: "A simple and human process",
      steps: [
        {
          number: "01",
          title: "First Exchange",
          description:
            "We take the time to listen, understand your situation and the needs of your loved one.",
        },
        {
          number: "02",
          title: "Needs Assessment",
          description:
            "Together, we define a personalized support plan, adapted to rhythm and preferences.",
        },
        {
          number: "03",
          title: "Tailored Accompaniment",
          description:
            "Our team acts with kindness, professionalism and constant attention to well-being.",
        },
      ],
    },
    values: {
      label: "Our Values",
      title: "What drives us every day",
      items: [
        {
          title: "Attention",
          description:
            "Every person is unique. We pay special attention to every detail for tailored support.",
        },
        {
          title: "Professionalism",
          description:
            "Continuous training, rigor and commitment define our approach to quality service.",
        },
        {
          title: "Heart",
          description:
            "Humanity is at the center of everything we do. We accompany with warmth, empathy and sincerity.",
        },
      ],
    },
    testimonials: {
      label: "Testimonials",
      title: "What our families say",
      items: [
        {
          quote:
            "Thanks to Présence & Sourire, my mother smiles again every week. The caregiver has become like a friend to her.",
          author: "Marie-Claire D.",
          relation: "Daughter of a beneficiary",
        },
        {
          quote:
            "A human and professional service. My father looks forward to his Tuesday walks. Thank you for your kindness.",
          author: "Philippe R.",
          relation: "Son of a beneficiary",
        },
        {
          quote:
            "I live far from my mother and felt guilty. Présence & Sourire gave me peace of mind. I know she is in good hands.",
          author: "Isabelle M.",
          relation: "Daughter of a beneficiary",
        },
      ],
    },
    contact: {
      label: "Contact",
      title: "Let's take the time to talk",
      subtitle:
        "Fill out the form below and we will get back to you as soon as possible.",
      form: {
        name: "Your name",
        phone: "Your phone number",
        message: "Your message (optional)",
        submit: "Send my request",
        sending: "Sending...",
        success: "Thank you! We will get back to you very soon.",
        error: "An error occurred. Please try again.",
      },
      calendly: {
        title: "Book a slot",
        description: "Schedule a discovery call with our team.",
        button: "Choose a time slot",
      },
      whatsapp: "Chat on WhatsApp",
      call: "Call us",
    },
    footer: {
      description:
        "Accompaniment and leisure for seniors and people with disabilities. Because every moment counts.",
      quickLinks: "Quick Links",
      contactTitle: "Contact",
      location: "Valais, Switzerland",
      legal: "Legal Notice",
      privacy: "Privacy Policy",
      rights: "All rights reserved.",
      followUs: "Follow Us",
    },
    whatsappFloat: "Chat on WhatsApp",
  },
};

export default translations;
